module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.list)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48d9620c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/g_plugin/comps/FormatHtml.vue
// module id = 1972
// module chunks = 1